import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function queryChargeList(requestBody) {
  return request({
    url: URL.act.invoice.queryChargeListUrl,
    method: 'post',
    data: requestBody
  })
}

export function queryBankSlipChargeList(requestBody) {
  return request({
    url: URL.act.invoice.queryBankSlipChargeListUrl,
    method: 'post',
    data: requestBody
  })
}

export function queryChargeJobList(requestBody) {
  return request({
    url: URL.act.invoice.queryChargeJobListUrl,
    method: 'post',
    data: requestBody
  })
}

export function queryInvoiceList(requestBody) {
  return request({
    url: URL.act.invoice.queryInvoiceListUrl,
    method: 'post',
    data: requestBody
  })
}

export function getNotInvoiceCharges(requestBody) {
  return request({
    url: URL.act.invoice.getNotInvoiceChargesUrl,
    method: 'post',
    data: requestBody
  })
}

export function generateInvoiceFaster(requestBody) {
  return request({
    url: URL.act.invoice.generateInvoiceFasterUrl,
    method: 'post',
    data: requestBody
  })
}

// 获取发票详情内容，不保存
export function getGenerateInvoiceInfoFunc(requestBody) {
  return request({
    url: URL.act.invoice.getGenerateInvoiceInfoUrl,
    method: 'post',
    data: requestBody
  })
}

// 保存页面调整后的发票详情
export function saveInvoiceFasterFunc(requestBody) {
  return request({
    url: URL.act.invoice.saveInvoiceFasterUrl,
    method: 'post',
    data: requestBody
  })
}

export function generateInvoiceForPool(requestBody) {
  return request({
    url: URL.act.invoice.generateInvoiceForPool,
    method: 'post',
    data: requestBody
  })
}

export function getInvoiceDetails(requestBody) {
  return request({
    url: URL.act.invoice.getInvoiceDetailsUrl,
    method: 'post',
    data: requestBody
  })
}

export function checkInvoiceNoExist2(requestBody) {
  return request({
    url: URL.act.invoice.checkInvoiceNoExist2Url,
    method: 'post',
    data: requestBody
  })
}

export function updateInvoices(requestBody, location) {
  return request({
    url: URL.act.invoice.updateInvoicesUrl,
    method: 'post',
    data: requestBody,
    params: { location }
  })
}

export function saveAmount(requestBody) {
  return request({
    url: URL.act.invoice.saveAmountUrl,
    method: 'post',
    data: requestBody
  })
}
export function syncInvoiceToET(body) {
  return request({
    url: URL.act.invoice.syncInvoiceToETUrl,
    method: 'post',
    params: body
  })
}

export function approveInvoices(requestBody) {
  return request({
    url: URL.act.invoice.approveInvoicesUrl,
    method: 'post',
    data: requestBody
  })
}

export function deleteInvoices(requestBody) {
  return request({
    url: URL.act.invoice.deleteInvoicesUrl,
    method: 'post',
    data: requestBody
  })
}

export function checkExportedToVoucher(requestBody) {
  return request({
    url: URL.act.invoice.checkExportedToVoucherUrl,
    method: 'post',
    data: requestBody
  })
}

export function revokeInvoices(requestBody) {
  return request({
    url: URL.act.invoice.revokeInvoicesUrl,
    method: 'post',
    data: requestBody
  })
}

export function redPunchInvoices(requestBody) {
  return request({
    url: URL.act.invoice.redPunchInvoicesUrl,
    method: 'post',
    data: requestBody
  })
}

export function outInterfaceExportBatch(requestBody, location) {
  return request({
    url: URL.act.invoice.outInterfaceExportBatchUrl,
    method: 'post',
    data: requestBody,
    params: { location }
  })
}

export function outInterfaceExportBatchEi(requestBody, location) {
  return request({
    url: URL.act.invoice.outInterfaceExportBatchEiUrl,
    method: 'post',
    data: requestBody,
    params: { location }
  })
}

export function outInterfaceExport(requestBody) {
  return request({
    url: URL.act.invoice.outInterfaceExportUrl,
    method: 'post',
    data: requestBody
  })
}

export function outInterfaceExportEi(requestBody) {
  return request({
    url: URL.act.invoice.outInterfaceExportEiUrl,
    method: 'post',
    data: requestBody
  })
}

export function outInterfacePrint(requestBody) {
  return request({
    url: URL.act.invoice.outInterfacePrintUrl,
    method: 'post',
    data: requestBody
  })
}

export function outInterfaceCancel(requestBody) {
  return request({
    url: URL.act.invoice.outInterfaceCancelUrl,
    method: 'post',
    data: requestBody
  })
}

export function loadJob2Invoice(requestBody) {
  return request({
    url: URL.act.invoice.loadJob2InvoiceUrl,
    method: 'post',
    data: requestBody
  })
}

export function saveDifferenceAdjustment(requestBody) {
  return request({
    url: URL.act.invoice.saveDifferenceAdjustment,
    method: 'post',
    data: requestBody
  })
}

export function taxEasyInvoiceDownLoad(requestBody) {
  return request({
    url: URL.act.invoice.taxEasyInvoiceDownLoadUrl,
    method: 'post',
    data: requestBody
  })
}

export function showChargeDetailChange(requestBody) {
  return request({
    url: URL.act.invoice.showChargeDetailChangeUrl,
    method: 'post',
    data: requestBody
  })
}

export function saveSplitCharge(requestBody, location) {
  return request({
    url: URL.act.invoice.saveSplitChargeUrl,
    method: 'post',
    data: requestBody,
    params: { location }
  })
}

export function printedInvoices(requestBody) {
  return request({
    url: URL.act.invoice.printedInvoicesUrl,
    method: 'post',
    data: requestBody
  })
}

export function getInvoiceMailHistory(requestBody) {
  return request({
    url: URL.act.invoice.getInvoiceMailHistoryUrl,
    method: 'post',
    data: requestBody
  })
}

export function sendEmail(requestBody) {
  return request({
    url: URL.act.invoice.sendEmailUrl,
    method: 'post',
    data: requestBody
  })
}

// 云税慧商-获取发票信息
export function getInvoiceNos(requestBody) {
  return request({
    url: URL.act.invoice.getInvoiceNosUrl,
    method: 'post',
    data: requestBody
  })
}

// 验证
export function checkToVoucher(requestBody) {
  return request({
    url: URL.act.invoice.checkToVoucherUrl,
    method: 'post',
    data: requestBody
  })
}

export function updateInvoiceTypeAndMakeType(requestBody) {
  return request({
    url: URL.act.invoice.updateInvoiceTypeAndMakeTypeUrl,
    method: 'post',
    data: requestBody
  })
}

export function relationEmailFunc(requestBody) {
  return request({
    url: URL.act.invoice.relationEmailUrl,
    method: 'post',
    data: requestBody
  })
}
// 批量同步LTS-发票
export function queryLtsInvoiceFunc(data) {
  return request({
    url: URL.act.invoice.batchPushLtsForInvoiceUrl,
    method: 'post',
    data
  })
}
// 获取lts的发票类型
export function ltsInvoiceTypeFunc(params) {
  return request({
    url: URL.act.invoice.ltsInvoiceTypeUrl,
    method: 'get',
    params
  })
}

// 百旺金穗云-获取发票号
export function getInvoiceNoByBwjsy(data) {
  return request({
    url: URL.act.invoice.getInvoiceNoByBwjsyUrl,
    method: 'post',
    data
  })
}

// 航天信息-诺诺-获取发票号
export function getInvoiceNoByHtxx(data) {
  return request({
    url: URL.act.invoice.getInvoiceNoByHtxxUrl,
    method: 'post',
    data
  })
}

// 校验发票是否存在文件记录
export function checkInvoiceExistfFile(params) {
  return request({
    url: URL.act.invoice.checkInvoiceExistfFile,
    method: 'get',
    params
  })
}

// 容津3.0纸质发票打印url
export function getTaxEasyThreePaperPrintUrl(data) {
  return request({
    url: URL.act.invoice.taxEasyThreePaperPrintUrl,
    method: 'post',
    data
  })
}

// 容津3.0纸质发票打印url
export function exportInvoiceQd(data) {
  return request({
    url: URL.act.invoice.exportInvoiceQd,
    method: 'post',
    data
  })
}

// 发票号导入
export function importInvoiceQd(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.act.invoice.importInvoiceQd,
    config: {
      headers: {
        'Content-Type': 'multipart/form-data; charset=UTF-8'
      }
    },
    method: 'post',
    data
  })
}

// 全电发票红冲
export function redPunchInvoicesQd(requestBody) {
  return request({
    url: URL.act.invoice.redPunchInvoicesQd,
    method: 'post',
    data: requestBody
  })
}

// 全电发票红冲查询
export function searchRedResult(requestBody) {
  return request({
    url: URL.act.invoice.searchRedResult,
    method: 'post',
    data: requestBody
  })
}

// 全电发票红字申请
export function redApply(requestBody) {
  return request({
    url: URL.act.invoice.redApply,
    method: 'post',
    data: requestBody
  })
}

// 全电发票红字申请撤销
export function redPunchApplyRollbackOrSearch(requestBody) {
  return request({
    url: URL.act.invoice.redPunchApplyRollbackOrSearch,
    method: 'post',
    data: requestBody
  })
}

// 全电发票认证二维码
export function authRecognition(requestBody) {
  return request({
    url: URL.act.invoice.authRecognition,
    method: 'post',
    data: requestBody
  })
}

// 全电-获取发票号-公共
export function getInvoiceNoQd(data) {
  return request({
    url: URL.act.invoice.getInvoiceNoQd,
    method: 'post',
    data
  })
}

// 太平导出发票信息
export function exportInvoiceDataFunc(data) {
  return request({
    url: URL.act.invoice.exportInvoiceDataUrl,
    method: 'post',
    data
  })
}

// 账单确认校验
export function checkConfirmBilling(data) {
  return request({
    url: URL.act.invoice.checkConfirmBillingUrl,
    method: 'post',
    data
  })
}

// 太平发票号导入
export function importInvoiceDataFunc(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.act.invoice.importInvoiceDataUrl,
    config: {
      headers: {
        'Content-Type': 'multipart/form-data; charset=UTF-8'
      }
    },
    method: 'post',
    data
  })
}

// 欧坚导出发票信息
export function exportInvoiceDataOJFunc(data) {
  return request({
    url: URL.act.invoice.exportInvoiceDataOJUrl,
    method: 'post',
    data
  })
}

// 欧坚发票号导入
export function importInvoiceDataOJFunc(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.act.invoice.importInvoiceDataOJUrl,
    config: {
      headers: {
        'Content-Type': 'multipart/form-data; charset=UTF-8'
      }
    },
    method: 'post',
    data
  })
}

export function checkExchangeRate(requestBody) {
  return request({
    url: URL.act.invoice.checkExchangeRate,
    method: 'post',
    data: requestBody
  })
}

// 杰贝越南税控-查询发票号
export function getInvoiceNoByEasyInvoice(data) {
  return request({
    url: URL.act.invoice.getInvoiceNoByEasyInvoiceUrl,
    method: 'post',
    data
  })
}

// 杰贝越南税控-下载发票
export function getInvoicePdfByEasyInvoice(data) {
  return request({
    url: URL.act.invoice.getInvoicePdfByEasyInvoiceUrl,
    method: 'post',
    data
  })
}

// 杰贝越南税控-取消发票
export function cancelEasyInvoice(requestBody) {
  return request({
    url: URL.act.invoice.cancelEasyInvoiceUrl,
    method: 'post',
    data: requestBody
  })
}

// 杰贝越南税控-查询发票状态
export function getInvoiceStatusByEasyInvoice(data) {
  return request({
    url: URL.act.invoice.getInvoiceStatusByEasyInvoiceUrl,
    method: 'post',
    data
  })
}

// 查询收款期限
export function getInvoiceCreditDetail(data) {
  return request({
    url: URL.act.invoice.getInvoiceCreditDetailUrl,
    method: 'post',
    data
  })
}

// 预览数据
export function previewDataFunc(requestBody) {
  return request({
    url: URL.act.invoice.previewDataUrl,
    method: 'post',
    data: requestBody
  })
}

// 预开发票
export function preGenerateInvoiceFunc(requestBody) {
  return request({
    url: URL.act.invoice.preGenerateInvoiceUrl,
    method: 'post',
    data: requestBody
  })
}
// 执行任务 调试执行
export function pushShippingExchangeDeBugFunc(requestBody) {
  return request({
    url: URL.act.invoice.pushShippingExchangeDeBugUrl,
    method: 'post',
    data: requestBody
  })
}

// 上海虹迈同步发票费用到用友
export function doHmSyncInvoiceChargeToYongYou(invoiceKeys) {
  return request({
    url: URL.act.invoice.hmSyncInvoiceChargeToYongYou,
    method: 'post',
    data: invoiceKeys
  })
}

// 青旅同步金蝶接口
export function doSyncInvoiceQL(invoiceKeys) {
  return request({
    url: URL.act.invoice.syncInvoiceCloudPlatformQL,
    method: 'post',
    data: invoiceKeys
  })
}

// 集翊达：用友U8 CLOUD接口对接
export function checkInvoiceToYYU8(invoiceKeys) {
  return request({
    url: URL.act.invoice.checkInvoiceToYYU8,
    method: 'post',
    data: invoiceKeys
  })
}

// 集翊达：用友U8 CLOUD接口对接
export function syncInvoiceToYYU8(data) {
  return request({
    url: URL.act.invoice.syncInvoiceToYYU8,
    method: 'post',
    data
  })
}

// 查询下载日志
export function queryDownloadLog(data) {
  return request({
    url: URL.sys.queryDownloadLog,
    method: 'post',
    data
  })
}

// 新增下载日志
export function addDownloadLog(data) {
  return request({
    url: URL.sys.insertDownloadLog,
    method: 'post',
    data
  })
}

// 合并发票文件
export function mergeInvoiceFile(data) {
  return request({
    url: URL.act.invoice.mergeInvoiceFile,
    method: 'post',
    data
  })
}

// 校验是否可以合并发票文件
export function checkMergeInvoiceFile() {
  return request({
    url: URL.act.invoice.checkMergeInvoiceFile,
    method: 'post'
  })
}

// 标记费用
export function signCharge(requestBody) {
  return request({
    url: URL.act.invoice.signCharge,
    method: 'post',
    data: requestBody
  })
}

// 取消标记费用
export function cancelSignCharge(requestBody) {
  return request({
    url: URL.act.invoice.cancelSignCharge,
    method: 'post',
    data: requestBody
  })
}

// 标记业务
export function signJob(requestBody) {
  return request({
    url: URL.act.invoice.signJob,
    method: 'post',
    data: requestBody
  })
}

// 取消标记业务
export function cancelSignJob(requestBody) {
  return request({
    url: URL.act.invoice.cancelSignJob,
    method: 'post',
    data: requestBody
  })
}
